<script setup>
// import { computed } from "vue";
import { useRoute } from "vue-router";
// import { useStore } from "vuex";

import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";

// const store = useStore();
// const isRTL = computed(() => store.state.isRTL);

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
</script>
<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <!-- Sección Ventas -->
      <div v-if="userRole === 'administrador' || userRole === 'ventas'">
        <li class="mt-3 nav-item">
          <h6
            class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4"
          >
            Comercial
          </h6>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/leads"
            :class="getRoute() === 'leads' ? 'active' : ''"
            navText="Leads"
          >
            <template v-slot:icon>
              <i class="ni ni-single-02 text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/cotizaciones"
            :class="getRoute() === 'cotizaciones' ? 'active' : ''"
            navText="Cotizaciones"
          >
            <template v-slot:icon>
              <i class="fas fa-file-invoice text-primary text-sm"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/ventas"
            :class="getRoute() === 'ventas' ? 'active' : ''"
            navText="Ventas"
          >
            <template v-slot:icon>
              <i class="ni ni-money-coins text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/area-comercial"
            :class="getRoute() === 'area-comercial' ? 'active' : ''"
            navText="Asesores Comerciales"
          >
            <template v-slot:icon>
              <i class="fas fa-user-tie text-primary text-sm"></i>
            </template>
          </sidenav-item>
        </li>
      </div>

      <!-- Sección Investigación -->
      <div v-if="userRole === 'administrador' || userRole === 'academico'">
        <li class="mt-3 nav-item">
          <h6
            class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4"
          >
            Investigación
          </h6>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/clientes"
            :class="getRoute() === 'clientes' ? 'active' : ''"
            navText="Clientes"
          >
            <template v-slot:icon>
              <i class="ni ni-single-02 text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/proyectos"
            :class="getRoute() === 'proyectos' ? 'active' : ''"
            navText="Trabajos de Investigación"
          >
            <template v-slot:icon>
              <i class="fas fa-book text-primary text-sm"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/area-academica"
            :class="getRoute() === 'area-academica' ? 'active' : ''"
            navText="Asesores Académicos"
          >
            <template v-slot:icon>
              <i class="fas fa-user-tie text-primary text-sm"></i>
            </template>
          </sidenav-item>
        </li>
      </div>

      <!-- Sección Configuración -->
      <div v-if="userRole === 'administrador'">
        <li class="mt-3 nav-item">
          <h6
            class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4"
          >
            Configuración
          </h6>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/servicios"
            :class="getRoute() === 'servicios' ? 'active' : ''"
            navText="Servicios"
          >
            <template v-slot:icon>
              <i class="fas fa-cogs text-primary text-sm"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            to="/empleados"
            :class="getRoute() === 'empleados' ? 'active' : ''"
            navText="Empleados"
          >
            <template v-slot:icon>
              <i class="fas fa-user-cog text-primary text-sm"></i>
            </template>
          </sidenav-item>
        </li>
      </div>

      <!-- Sección Usuario -->
      <br />
      <div>
        <li class="mt-3 nav-item">
          <h6
            class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4"
          >
            Usuario
          </h6>
        </li>
        <li class="mt-3 nav-item">
          <p
            class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4"
          >
            <i class="fas fa-user " style="color: green"></i>
            <!-- Ícono de usuario en verde -->
            {{ userName }}
          </p>
        </li>

        <li class="mt-3 nav-item" @click="handleLogout">
          <p
            class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4"
            role="button"
          >
            <i class="fas fa-power-off" style="color: red"></i>
            <!-- Ícono de apagado rojo -->
            Cerrar Sesión
          </p>
        </li>
      </div>

      <!-- <li class="nav-item">
        <sidenav-item
          @click="logout"
          navText="Logout"
        >
          <template v-slot:icon>
            <i class="fas fa-sign-out-alt text-danger text-sm"></i>
          </template>
        </sidenav-item>
      </li> -->

      <!-- <li class="nav-item">
        <sidenav-item
          to="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          :navText="isRTL ? 'لوحة القيادة' : 'Dashboard'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/tables"
          :class="getRoute() === 'tables' ? 'active' : ''"
          :navText="isRTL ? 'الجداول' : 'Tablsdsddes'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/billing"
          :class="getRoute() === 'billing' ? 'active' : ''"
          :navText="isRTL ? 'الفواتیر' : 'Billing'"
        >
          <template v-slot:icon>
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/virtual-reality"
          :class="getRoute() === 'virtual-reality' ? 'active' : ''"
          :navText="isRTL ? 'الواقع الافتراضي' : 'Virtual Reality'"
        >
          <template v-slot:icon>
            <i class="ni ni-app text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/rtl-page"
          :class="getRoute() === 'rtl-page' ? 'active' : ''"
          navText="RTL"
        >
          <template v-slot:icon>
            <i class="ni ni-world-2 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="mt-3 nav-item">
        <h6
          v-if="isRTL"
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'"
        >
          صفحات المرافق
        </h6>

        <h6
          v-else
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'"
        >
          ACCOUNT PAGES
        </h6>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="isRTL ? 'حساب تعريفي' : 'Profile'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/signin"
          :class="getRoute() === 'signin' ? 'active' : ''"
          :navText="isRTL ? 'تسجيل الدخول' : 'Sign In'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/signup"
          :class="getRoute() === 'signup' ? 'active' : ''"
          :navText="isRTL ? 'اشتراك' : 'Sign Up'"
        >
          <template v-slot:icon>
            <i class="ni ni-collection text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->
    </ul>
  </div>

  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :card="{
        title: 'Need Help?',
        description: 'Please check our docs',
        links: [
          {
            label: 'Documentation',
            route:
              'https://www.creative-tim.com/learning-lab/vue/overview/argon-dashboard/',
            color: 'dark',
          },
          {
            label: 'Buy now',
            route:
              'https://www.creative-tim.com/product/vue-argon-dashboard-pro?ref=vadp',
            color: 'success',
          },
        ],
      }"
    />
  </div>
</template>
<script>
import AuthService from "../../services/AuthService";
export default {
  data() {
    return {
      userName: "",
      userRole: null,
    };
  },
  created() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      this.userRole = user.empleado
        ? user.empleado.area_empleados.toLowerCase()
        : null; // Asegúrate de que estás obteniendo el rol correcto
      this.userName = user.nombres_completos_persona || "Usuario"; // Muestra el nombre del usuario o 'Usuario' si no está disponible
    }
  },
  methods: {
    handleLogout() {
      AuthService.logout(); // Llama a la función de logout
      this.$router.push("/login");
    },
  },
};
</script>